import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { Checkbox, Typography, IconButton } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React, { useState } from 'react'

import NoDataImage from '../../../assets/images/NoDataWithNoText.png'
import { getTranslate } from '../../../localization'
import { ReservedField } from '../../../types/inventory'
import { ModalRow } from './modalRow'
import { ModalRowSkeleton } from './modalRowSkeleton'
import useStyles from './styles/modalTable'

interface ModalTableProps {
  data: ReservedField[]
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      reservedFields: ReservedField[]
    }>
  >
  loading: boolean
}

export const ModalTable: React.FC<ModalTableProps> = ({
  data,
  refetch,
  loading
}) => {
  const classes = useStyles()
  const [checked, setChecked] = useState<boolean>(true)

  return (
    <div className={classes.root}>
      <div className={classes.tableHeaderForModal}>
        <div>
          <Typography className={classes.tableHeader} variant="h4">
            {getTranslate('CRS Number')}
          </Typography>
        </div>
        <div>
          <Typography className={classes.tableHeader} variant="h4">
            {getTranslate('Version')}
          </Typography>
        </div>
        <div>
          <Typography className={classes.tableHeader} variant="h4">
            {getTranslate('Action')}
          </Typography>
        </div>
        <div>
          <Typography className={classes.tableHeader} variant="h4">
            {getTranslate('Created At')}
          </Typography>
        </div>
        <div>
          <Typography className={classes.tableHeader} variant="h4">
            {getTranslate('Updated At')}
          </Typography>
        </div>
        <div className={classes.contentWithCheckbox}>
          <Checkbox
            color="primary"
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.checked)
            }}
            disableRipple
            size="small"
            classes={{ root: classes.checkBox, checked: classes.checkBox }}
          />
          <Typography className={classes.tableHeader} variant="h4">
            {getTranslate('Deleted At')}
          </Typography>
        </div>
        <div>
          <IconButton onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </div>
      </div>
      {loading ? (
        Array(7)
          .fill('')
          .map((_, index) => <ModalRowSkeleton key={index} />)
      ) : data.length > 0 ? (
        data
          .filter((item) => {
            if (checked) {
              return true
            } else {
              return !item.deletedAt
            }
          })
          .map((ele, index) => (
            <ModalRow key={index} data={ele} index={index} />
          ))
      ) : (
        <div className={classes.noDataImageContainer}>
          <img src={NoDataImage} />
          <Typography variant="subtitle1">
            {getTranslate('No Documents')}
          </Typography>
        </div>
      )}
    </div>
  )
}
